import { Clickable, Hidden } from '@ahmdigital/ui';
import Icon from '@ahmdigital/icons-web';

import constants from '../../ahm-constants';
import styles from './styles.module.sass';

const icon = <Icon name="phone-circle" size="medium" className={styles.icon} />;
const {
  CONTACT: { PHONE },
  URLS,
} = constants;

type PhoneProps = {
  withIcon?: boolean;
};

const Phone = ({ withIcon = false }: PhoneProps) => (
  <>
    <Hidden xs sm>
      <Clickable to={URLS.SALES.CONTACT_US} className={styles.link}>
        {withIcon && icon}
        {PHONE.PRETTY}
      </Clickable>
    </Hidden>
    <Hidden md lg df>
      <Clickable to={`tel:${PHONE.STANDARD}`} className={styles.link}>
        {withIcon && icon}
        {PHONE.PRETTY}
      </Clickable>
    </Hidden>
  </>
);

export default Phone;
